import React from "react";
import Tile from "../../components/Tile/Tile";
import "./ExploreCareers.css";
import { ContentfulTileProps } from "../../utils/contentful-helpers";
import { bookmarkEventBuilder, sendEvent } from "../../utils/event-helpers";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { toggleResourceBookmark } from "../../stores/bookmarks/resourceBookmarksSlice";

export interface ExploreCareersTilesProps {
  resourceTiles: ContentfulTileProps[];
}

const ExploreCareersTiles = ({
  resourceTiles,
}: ExploreCareersTilesProps) => {
  const dispatch = useAppDispatch();
  const { userId, sessionId } = useAppSelector((state) => state.session);
  const bookmarks = useAppSelector((state) => state.resourceBookmarks.bookmarks);
  
  const handleBookmarkExploreCareers = (resourceTile: ContentfulTileProps) => {
    const { id, title, description } = resourceTile;
    const isBookmarked = bookmarks.some((bookmark) => bookmark.resourceId === id);
    const eventData = bookmarkEventBuilder(!isBookmarked, userId, sessionId, "ExploreCareersTile", title, {
      bookmarkedResource: {
        title: title,
        description: JSON.stringify(description),
        resource_id: id,
      },
    });
    sendEvent(eventData);

    dispatch(
      toggleResourceBookmark({ userId, resourceId: id })
    );
  };

  return (
    <div className="internship-wrapper">
      <div className="explore-careers-container">
        {resourceTiles.map((tile) => (
          <Tile
            key={tile.id}
            id={tile.id}
            title={tile.title}
            description={tile.description}
            thumbnail={tile.thumbnail}
            url={tile.url}
            isResearchPage={false}
            onBookmark={() => {
              handleBookmarkExploreCareers(tile);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ExploreCareersTiles;
